import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export function LanguageToggle({ className = "" }) {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-1 px-2 py-1 rounded-md bg-[#262626] hover:bg-[#333] transition-colors text-sm font-medium ${className}`}
      title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
      data-testid="language-toggle"
    >
      <span className={language === 'en' ? 'text-white' : 'text-[#666]'}>EN</span>
      <span className="text-[#555]">/</span>
      <span className={language === 'es' ? 'text-[#FF5D01]' : 'text-[#666]'}>ES</span>
    </button>
  );
}

export default LanguageToggle;
